import { type FC } from 'react'

import {
  ACTIONS,
  DESCRIPTIONS,
  ERROR_MESSAGES,
  MENU,
  SUCCESS_MESSAGES
} from '@/constants/common/message.constants'
import { createTruckImportJob } from '@/features/truck-import-jobs/api'

import { isOpenTruckImportModalAtom } from '../../-states'
import { CsvImportModal } from '../CsvImportModal/CsvImportModal'

type Props = {
  tenantKey: string
}

/**
 * 車両マスタインポートModal
 */
export const TruckImportModal: FC<Props> = ({ tenantKey }) => {
  return (
    <CsvImportModal
      tenantKey={tenantKey}
      isOpenAtom={isOpenTruckImportModalAtom}
      modalTitle={MENU.TRUCK_MASTER_IMPORT}
      draggerTitle={ACTIONS.UPLOAD_TRUCK_DATA}
      draggerDescription={DESCRIPTIONS.UPLOAD_TRUCK_DATA}
      createImportJob={(formValue, dcId) =>
        createTruckImportJob({ tenantKey, dto: { ...formValue, dcId } })
      }
      successMessage={SUCCESS_MESSAGES.STARTED_TRUCK_IMPORT}
      errorMessage={ERROR_MESSAGES.FAILED_TO_START_TRUCK_IMPORT}
      historyRoute="/$tenantKey/settings/truck-import-jobs"
    />
  )
}
